/**
 *
 * Asynchronously loads the LocationFilterPopup component
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
